import { render } from "./ReportUserConfirmationSuccessPage.vue?vue&type=template&id=7506a8bc&ts=true"
import script from "./ReportUserConfirmationSuccessPage.vue?vue&type=script&lang=ts"
export * from "./ReportUserConfirmationSuccessPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__